const CONST = require('plugin_frontend_core/constants');
const helpers = require('plugin_checkout/cart/helpers');

const selectors = {
    addCheque: '.js-add-cheque',
    errorMessage: '.js-waardecheck-cant-be-added',
    errorModalTrigger: '.js-btn-waardecheck-cant-be-added',
    form: '.js-checkout-step-payment'
};

/**
 * @private onAddChequeClick
 * @param {EventListenerObject} event -
 */
function onAddChequeClick(event) {
    event.preventDefault();

    const $self = $(this);
    const url = $self.data(CONST.attributes.action);
    const $form = $(selectors.form);
    $.spinner().start();
    $.ajax({
        url: url,
        type: 'POST',
        data: $form.serialize(),
        context: this,
        dataType: 'json',
        success: function (data) {
            if (data.isWaardecheckAdded) {
                window.location.href = window.location.href;
            } else {
                $(selectors.errorMessage).html(data.message);
                $(selectors.errorModalTrigger).trigger(CONST.events.click);
                setTimeout(function () {
                    $.spinner().stop();
                }, 1500);
            }
        },
        error: function (error) {
            if (error.responseJSON.redirectUrl) {
                window.location.href = error.responseJSON.redirectUrl;
            } else {
                helpers.createErrorNotification(error.responseJSON.errorMessage);
                setTimeout(function () {
                    $.spinner().stop();
                }, 1500);
            }
        }
    });
}

module.exports = function init() {
    $(selectors.addCheque).on(CONST.events.click, onAddChequeClick);
};
